import "../../Main.css";
import "../../ContentFrame.css";

import { MenuBar } from "../../../components/MenuBar";
import Address from "../../../components/Address";
import HistoryCard from "./HistoryCard";
import { getCompanyHistory, getStandardYearList } from "../../../services/CompanyHistoryAPI";

import React, { useState, useEffect } from "react";

export const CompanyHistory = () => {
    const [historyCards, setHistoryCards] = useState([]);
    const [standardYearList, setStandardYearList] = useState([]);

    const setCompanyHistoryCards = (historys, startYearIndex) => {
        let cards = [];
        let startYear = standardYearList[startYearIndex].standardYear;
        let endYear =
            startYearIndex == standardYearList.length - 1 ? 0 : standardYearList[startYearIndex + 1].standardYear;

        historys.map((history, index) => {
            if (history.year < startYear && history.year >= endYear) {
                cards.push(
                    <HistoryCard
                        key={index}
                        history={history}
                        setHistoryCards={setHistoryCards}
                        updateCompanyHistoryCards={updateCompanyHistoryCards}
                    />
                );
            }
        });

        return { year: standardYearList[startYearIndex].standardYear, cards: cards };
    };

    const setCompanyHistoryCardsWithYear = (historys) => {
        let historyCards = [];

        standardYearList.map((year, index) => {
            historyCards.push(setCompanyHistoryCards(historys, index));
        });

        setHistoryCards(historyCards);
    };

    const updateCompanyHistoryCards = () => {
        getCompanyHistory().then((result) => {
            setCompanyHistoryCardsWithYear(result);
        });
    };

    const updateStandardYearList = async () => {
        let yearList = [{ id: null, standardYear: new Date().getFullYear() }];

        getStandardYearList().then((result) => {
            result.map((year, index) => {
                yearList.push({ id: null, standardYear: year.standardYear });
            });
            setStandardYearList(yearList);
        });
    };

    useEffect(() => {
        updateStandardYearList();
    }, []);

    useEffect(() => {
        updateCompanyHistoryCards();
    }, [standardYearList]);

    const getHistoryCardWithYear = () => {
        let historyCardsWithYear = [];

        {
            historyCards.map((historyCard, index) => {
                historyCardsWithYear.push(
                    <div key={index}>
                        <span className="content_title" style={{ fontWeight: "600", marginTop: "50px" }}>
                            Untill {historyCard.year}
                        </span>
                        <div className="flex flex-col w-full h-full ml-72 mt-10">{historyCard.cards}</div>
                    </div>
                );
            });
        }

        return historyCardsWithYear;
    };

    return (
        <div className="main_container">
            <MenuBar selected_page={2} />

            <div className="common_frame_container">
                <div className="common_content_container">
                    <div style={{ width: "100%", height: "100px" }}></div>
                    <span className="page_title">회사연혁</span>

                    {getHistoryCardWithYear()}
                    <div style={{ width: "100%", height: "100px" }}></div>
                </div>
            </div>

            <Address />
        </div>
    );
};
